import { render, staticRenderFns } from "./relatorio-dre.vue?vue&type=template&id=91386b7e"
import script from "./relatorio-dre.vue?vue&type=script&lang=js"
export * from "./relatorio-dre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports